import React, { useEffect, useContext } from 'react';
import AddDeal from './AddDeal';
import AddOrganization from './AddOrganization';
import AddPerson from './AddPerson';
import AddActivity from './AddActivity';
import FetchPipedriveDataButton from './FetchPipedriveDataButton';
import { fetchAllSelectOptions } from './shared/SelectOptionsFunctions';
import { DataContext as SharedDataContext } from '../../stores/crm-store';
import DealFilterDropdown from './deal/DealFilterDropdown';
import ExportCrmToExcel from './shared/ExportCrmToExcel';
import { DataContext as CovDataStore } from '../../store';
import GlobalSearchBox from './GlobalSearch';
import CrmNavMenuDropdown from './shared/CrmNavMenuDropdown';

const NavMenu = ({ type }) => {
    let hideExcelButton = false;
    switch (type) {
        case 'CrmDealDetails':
        case 'CrmPersonDetails':
        case 'CrmOrganizationDetails':
        case 'CrmInsights':
        case 'CrmActiveDeals':
            hideExcelButton = true;
            break;
    }
    //------------------------ Make sure select options are fetched
    const { store, dispatch } = useContext(SharedDataContext);
    useEffect(() => {
        if (!store.areSelectOptionsFetched && !store.isFetchingSelectOptions) {
            fetchAllSelectOptions(dispatch);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const { store: covStore } = useContext(CovDataStore);
    const user = covStore?.user;

    let excelButton = <ExportCrmToExcel crmPage={type} />;
    if (excelButton && excelButton.length) {
        excelButton = <div className='d-flex pl-4'>{excelButton}</div>;
    }

    const determineClass = (buttonType) => {
        return `btn btn-light text-nowrap ${type === buttonType ? 'active' : ''}`;
    };

    return (
        <>
            <div className='crm-navbar p-3 d-flex position-sticky' style={{ left: 0, zIndex: 1000 }}>
                <div className='d-flex text-nowrap align-items-center' style={{ width: 500 }}>
                    {type === 'CrmDeals' || type === 'CrmAvailableConsultants' ? <AddDeal /> : null}
                    {type === 'CrmOrganizations' ? <AddOrganization /> : null}
                    {type === 'CrmPersons' ? <AddPerson /> : null}
                    {type === 'CrmActivities' ? <AddActivity /> : null}
                    <FetchPipedriveDataButton />
                    <GlobalSearchBox />
                </div>
                <div className='d-inline-flex align-items-center ml-auto '>
                    {<DealFilterDropdown type={type} />}
                    {<CrmNavMenuDropdown type={type} />}
                    {hideExcelButton ? null : excelButton}
                </div>
            </div>
        </>
    );
};

export default NavMenu;
